import { render, staticRenderFns } from "./form-summary.vue?vue&type=template&id=42a843fa&"
import script from "./form-summary.vue?vue&type=script&lang=js&"
export * from "./form-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports